<script>
	import Header from './Header.svelte'
	import Main from './Main.svelte'
	import Footer from './Footer.svelte'
</script>

<div>
	<Header />
	<Main />
	<Footer />
</div>

<style global>
	:global(*) {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}
	:global(body) {
		font: 18px pt-sans, sans-serif;
	}
</style>

